import '@atlaskit/css-reset';
import './styles/global.css';

// jQuery needed for community-library analytics
import jQuery from 'jquery';
import { hydrateRoot } from 'react-dom/client';
import { ConsentValidator } from '@atlassian/community-library';

import { UserProvider } from './context/UserContext';
import { User } from './types';
import { FeatureGatesBootstrapValues, initializeFeatureGatesClient } from './utils/initializeFeatureGates';
import { getAssetUrl, getEnvironment, getLogoutUrl } from './services/http/user';
import { App } from './App';
import { initializeSentry } from './utils/initializeSentry';

// jQuery needed for community-library analytics
Object.defineProperty(globalThis, 'jQuery', {
  value: jQuery,
});

// declaring updatePolicyLinks for OneTrust to call it in the App.tsx
export interface OneTrustWrapper {
  updatePolicyLinks: () => void;
}

declare global {
  interface Window {
    AtlOneTrustWrapper?: {
      updatePolicyLinks?: () => void;
    };
  }
}

const typedGlobalThis = globalThis as typeof globalThis & {
  __CURRENT_USER__: User;
  __IS_CONSENTED__: boolean;
  __FEATURE_GATES_VALUES__: FeatureGatesBootstrapValues;
};

initializeSentry();

initializeFeatureGatesClient(typedGlobalThis.__CURRENT_USER__, typedGlobalThis.__FEATURE_GATES_VALUES__).then(() =>
  hydrateRoot(
    document.getElementById('root') as HTMLElement,
    <UserProvider userInfo={typedGlobalThis.__CURRENT_USER__}>
      <ConsentValidator
        onLogout={() => window.location.replace(getLogoutUrl())}
        onConsentError={() => window.location.replace('/user/error/consent-failed')}
        coverImageSrc={getAssetUrl('/images/welcomeIllustration.png')}
        aaid={typedGlobalThis.__CURRENT_USER__?.account_id}
        isUserConsented={typedGlobalThis.__IS_CONSENTED__}
        env={getEnvironment()}
      >
        <App />
      </ConsentValidator>
    </UserProvider>,
  ),
);
